import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {atomIconSizes} from '@s-ui/react-atom-icon'
import AtomToast, {atomToastAutoCloseTimes} from '@s-ui/react-atom-toast'
import Context from '@s-ui/react-context'
import IconCircleCheckOutline from '@adv-mt/mt-svg-icons/lib/CircleCheckOutline.js'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'
import IconInfoOutline from '@adv-mt/mt-svg-icons/lib/InfoOutline.js'

const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error'
}

const NOTIFICATIONS = {
  [NOTIFICATION_TYPES.SUCCESS]: {
    icon: <IconCircleCheckOutline size={atomIconSizes.medium} />
  },
  [NOTIFICATION_TYPES.ERROR]: {
    icon: <IconInfoOutline size={atomIconSizes.medium} />
  }
}

const NotificationsStepper = ({onClose, type, message}) => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const isMobile = config.get('isMobile')
  const notificationConfig = NOTIFICATIONS[type]

  const position = isMobile ? 'top' : 'top-right'

  const baseClasses = cx('mt-NotificationsStepper', type && `mt-NotificationsStepper--${type}`)

  return (
    <AtomToast
      autoCloseTime={atomToastAutoCloseTimes.short}
      globalClose
      position={position}
      iconClose={<IconClose size={atomIconSizes.medium} />}
      onClose={onClose}
      show
    >
      <div className={baseClasses}>
        {notificationConfig.icon}
        <p className="mt-NotificationStepperText">{message}</p>
      </div>
    </AtomToast>
  )
}

NotificationsStepper.displayName = 'NotificationsStepper'
NotificationsStepper.propTypes = {
  onClose: PropTypes.func,
  type: PropTypes.oneOf(Object.values(NOTIFICATION_TYPES)),
  message: PropTypes.string
}

export default NotificationsStepper
